export default __webpack_public_path__ + "static/media/ticket.758ccf49.svg";